import { Zap, Mail, MessageCircle } from "lucide-react";

const DISCORD_INVITE = "https://discord.gg/vangtechsub";

export default function Footer() {
  return (
    <footer className="border-t-2 border-[#111114] bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-violet-600 border-2 border-[#111114] flex items-center justify-center">
              <Zap className="w-4 h-4 text-white" fill="white" />
            </div>
            <span className="font-display font-extrabold">VangTech Subs</span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm font-semibold">
            <a href={DISCORD_INVITE} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 rounded-full bg-[#5865F2] text-white border-2 border-[#111114] px-3 py-1.5 hover:bg-[#4752c4]" data-testid="footer-discord">
              <MessageCircle className="w-4 h-4" /> Join our Discord
            </a>
            <span className="chip bg-amber-200">Discord bot · coming soon</span>
            <a href="mailto:admin@vangstechsubs.com" className="flex items-center gap-1.5 text-[#111114] hover:text-violet-600" data-testid="footer-support-email"><Mail className="w-4 h-4" /> Support</a>
            <a href="mailto:accounts@vangstechsubs.com" className="flex items-center gap-1.5 text-[#111114] hover:text-violet-600" data-testid="footer-accounts-email"><Mail className="w-4 h-4" /> Accounts</a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-slate-200 text-center text-xs text-slate-500 leading-relaxed max-w-3xl mx-auto">
          VangTech Subs is owned and operated by <span className="font-semibold text-[#111114]">Vanguard Tech Limited</span> (NZBN 9429053750594 · Company No. 94-37-764).
          Payments are securely processed by Vanguard Tech Limited's third-party provider <span className="font-semibold text-[#111114]">Stripe</span>; Stripe's terms &amp; conditions apply.
          A 13.5% platform fee applies to subscriptions &amp; product sales. Payouts are made via <span className="font-semibold text-[#111114]">PayPal</span> every 2 weeks on Mondays &amp; Fridays (NZST), with a $2 payout fee; requests made after 12:00am NZST are processed the next business day. Prices default to NZD.
          <br />© {new Date().getFullYear()} Vanguard Tech Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
